import { ThunkAction, configureStore } from '@reduxjs/toolkit';
import { Action, combineReducers } from 'redux';
import userReducer from './userSlice';
import coctailsReducer from './coctailsSlice';
import gamesReducer from './gamesSlice';

const rootReducer = combineReducers({
  userReducer,
  coctailsReducer,
  gamesReducer,
});

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
export type AppState = ReturnType<AppStore['getState']>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, AppState, unknown, Action>;
